/** Relatório público (link de visualização) — perfil + briefing + crescimento. Fase 5. */
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { api } from "../lib/api";
import type { Metric } from "../lib/metrics";
import { BrandMark } from "../ui/BrandMark";
import { BriefingBlocks } from "../ui/BriefingBlocks";
import { GrowthPanel } from "../ui/GrowthPanel";
import { FullScreenLoader } from "../ui/ProtectedRoute";

interface ReportData {
  profile: {
    name: string; businessName: string | null; tier: string;
    segment: string | null; city: string | null; positioning: string | null;
  };
  briefing: { responses: Record<string, string>; status: "draft" | "submitted" };
  metrics: Metric[];
}

export function RelatorioPublico() {
  const { token } = useParams();
  const [data, setData] = useState<ReportData | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get<ReportData>(`/public/report/${token}`).then(setData).catch(() => setError(true));
  }, [token]);

  if (error) {
    return (
      <div className="app-shell flex min-h-dvh flex-col items-center justify-center px-6 text-center">
        <BrandMark variant="vinho" className="h-6" />
        <h1 className="type-h2 mt-4 text-text-cream">Relatório indisponível</h1>
        <p className="type-body mt-2 text-text-secondary">Este link não é válido ou foi desativado.</p>
      </div>
    );
  }
  if (data === null) return <FullScreenLoader />;

  return (
    <div className="app-shell min-h-dvh px-5 py-6">
      <div className="mx-auto w-full max-w-3xl">
        <BrandMark variant="vinho" className="h-6" />
        <h1 className="type-h1 mt-3 text-text-cream">{data.profile.name}</h1>
        {data.profile.businessName !== null && (
          <p className="type-body text-text-secondary">{data.profile.businessName}</p>
        )}
        <div className="mt-2 flex flex-wrap gap-3 type-caption text-text-tertiary">
          {data.profile.segment !== null && <span>{data.profile.segment}</span>}
          {data.profile.city !== null && <span>{data.profile.city}</span>}
        </div>

        <h2 className="type-h3 mt-8 text-text-cream">Crescimento</h2>
        <div className="mt-3">
          <GrowthPanel metrics={data.metrics} />
        </div>

        <h2 className="type-h3 mt-8 text-text-cream">Diagnóstico</h2>
        <div className="mt-3">
          <BriefingBlocks responses={data.briefing.responses} />
        </div>
      </div>
    </div>
  );
}
